import NotificationItem from './NotificationItem';
import styles from '../NotificationPreferences.module.css';

export default function NotificationSection({
  items,
  values,
  onChange,
  onItemClick,
}) {
  return (
    <div className={styles.section}>
      <div className={styles.list}>
        {items.map((item, index) => (
          <NotificationItem
            key={item.name}
            name={item.name}
            label={item.label}
            description={item.description}
            checked={values[item.name]}
            onChange={onChange}
            onClick={onItemClick}
            isLast={index === items.length - 1}
          />
        ))}
      </div>
    </div>
  );
}
